import VueForm from '../../../scripts/VueFormSetup'
var resetPassword = VueForm.FormSubmit('FormLogin',
    {
        Email: '',
        Password: '',
        ConfirmPassword: '',
        code: '',
        valid: '',
    },
    'ID')
resetPassword.methods.close = function () {
    this.Email = ''
    this.Password = ''
    this.ConfirmPassword = ''
    this.code = ''
    this.$router.replace("/")
}
resetPassword.methods.submit = function () {
    if (this.$refs.form.validate()) {
        var queryString = this.parseQuerString(window.location.hash.substring(16))
        this.$ajax.post("/Account/ApplicationResetPassword", {
            Email: this.Email,
            Password: this.Password,
            ConfirmPassword: this.Password,
            code: queryString.code
        }).then(params => {
            this.complete(params)
        }).catch(params => {
            this.complete(params)
        })
    }
}
resetPassword.methods.parseQuerString = function (query) {
    var vars = query.split("&");
    var query_string = {};
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        var key = decodeURIComponent(pair[0]);
        var value = decodeURIComponent(pair[1]);
        // If first entry with this name
        if (typeof query_string[key] === "undefined") {
            query_string[key] = decodeURIComponent(value);
            // If second entry with this name
        } else if (typeof query_string[key] === "string") {
            var arr = [query_string[key], decodeURIComponent(value)];
            query_string[key] = arr;
            // If third or later entry with this name
        } else {
            query_string[key].push(decodeURIComponent(value));
        }
    }
    return query_string;
}
resetPassword.methods.complete = function (params) {
    var instance = this
    if (params.status === 'success') {
        if (params.data === 'OK') {
            this.$root.$snackbar('Tu contraseña ha sido restablecida', { color: 'success' })
            this.close()
        } else {
            this.$root.$snackbar('La solicitud se realizó con éxito, pero no pudimos determinar qué sucedió en esta solicitud. Si el error persiste, póngase en contacto con el equipo de soporte.', { color: 'error' })
        }
    } else {
        this.$root.$snackbar('No pudimos determinar qué sucedió en esta solicitud. Por favor, compruebe su conexión a Internet y vuelva a intentarlo. Si el error persiste, póngase en contacto con el equipo de soporte.', { color: 'error' })
        //instance.$parent.$parent.$parent.show = true
        //instance.$router.replace('/dashboard')
    }
}
export default resetPassword


// WEBPACK FOOTER //
// ./src/components/account/resetPassword/script.js